export enum PropertyStepsEnum {
  preStepPropertyType = 'pre_step_property_type',
  generalBase = 'general_base',
  generalSecond = 'general_second',
  propertyFeatures = 'property_features',
  propertyAmenities = 'property_amenities',
  propertySkillsAmenities = 'property_skills_amenities',
  propertyPhoto = 'cover_photo',
  propertyResidents = 'property_residents',
  propertyLandlord = 'property_landlord',
  propertyShare = 'property_share',
  congratulations = 'congratulations',
}
